export enum passwordLengthEnum {
  imoNumberLength = 10,
  vinNumberLength = 10,
}
